import {
	Height as CardSize,
	type CornerStyle,
	type RenderVariant,
	type SegmentationTargets,
} from '@atlassian/company-hub-common/types';

export const DEFAULT_DYNAMIC_CARDS_COUNT = 3;

export { CardSize };

export type CardsExtensionParameters = {
	alignment?: Alignment;
	audienceSegmentationGroupIds?: string[]; // group preferences stored via this field when segmentationTarget is ALL
	backgroundColor?: string;
	borderColor?: string;
	cardCount?: number;
	cards: Card[];
	cornerRadius?: number;
	cornerStyle?: CornerStyle;
	extensionTitle: string;
	filters?: Filters;
	isAutoscrollEnabled?: boolean;
	isAvatarShown: boolean;
	isDescriptionShown?: boolean;
	isIconShown?: boolean;
	isImageShown?: boolean;
	isLabelShown?: boolean;
	isPaddingEnabled?: boolean;
	isPublishDateShown: boolean;
	isSegmentationShown: boolean;
	isSocialStatsShown?: boolean;
	layout?: CardsLayout;
	orientation?: Orientation;
	renderVariant: RenderVariant;
	segmentationTarget?: SegmentationTargets;
	size: CardSize;
	textColor?: string;
	version: string;
};

export enum Orientation {
	ROW = 'row',
	STACKED = 'stacked',
}

export enum Alignment {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
}

export type Filters = {
	[filter: string]: any;
};

export enum ImagePosition {
	TOP = 'top',
	MIDDLE = 'middle',
	BOTTOM = 'bottom',
}

export type Card = {
	audienceSegmentationGroupIds?: string[];
	backgroundColor?: string;
	cardId: string;
	confluencePageId?: string;
	description?: string;
	imageAltText?: string;
	imagePosition?: ImagePosition;
	imageSrc?: string;
	isDescriptionUserEdited?: boolean;
	isLabelHidden?: boolean;
	isLinkUserEdited?: boolean;
	isTitleUserEdited?: boolean;
	label?: string;
	labelColor?: string;
	link: string;
	linkResourceType?: string;
	textColor?: string;
	title?: string;
};

export type ResolvedLinkDataObject = {
	data: {
		image?: {
			url?: string;
		};
		name?: string;
		summary?: string;
	};
	meta: {
		objectId?: string;
		resourceType?: string;
	};
};

export enum CardsLayout {
	FIXED_IMAGE_HEIGHT = 'fixed-image-height',
	FLEXIBLE_IMAGE_HEIGHT = 'flexible-image-height',
}
